import React from 'react';
import { Box, Icon, Text, VStack } from '@chakra-ui/react';

interface MailActionCardProps {
    icon: React.ElementType;
    label: string;
    fontSize?: string;
    onClick: () => void;
    disabled?: boolean;
}

const MailActionCard: React.FC<MailActionCardProps> = ({ icon, label, fontSize, onClick, disabled }) => {
    return (
        <Box
            as="button"
            onClick={disabled ? undefined : onClick}
            p={4}
            bg={disabled ? 'gray.300' : 'yellow.600'}
            _hover={disabled ? {} : { bg: 'yellow.700' }}
            transition="background-color 0.2s"
            cursor={disabled ? 'not-allowed' : 'pointer'}
            flex={1}
            minW="150px"
            opacity={disabled ? 0.7 : 1}
        >
            <VStack gap={2} align="center">
                {/* Иконка */}
                <Icon as={icon} boxSize={7} color="black" />
                {/* Подпись */}
                <Text fontSize={fontSize || 'md'} fontWeight="400" color="black" textAlign="center">
                    {label}
                </Text>
            </VStack>
        </Box>
    );
};

export default MailActionCard;
